import { useEffect, useState } from "react";
import { useParams, Link as RouterLink, useNavigate } from "react-router-dom";
import styles from "./TodayRequestList.module.css";
import { Button, FormControl, TextField, Radio, RadioGroup, FormControlLabel, FormLabel, Snackbar, Alert } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import Loader from "../components/Loader";
import { authData } from "../components/GetAuth";

const DriverPaymentDetails = () => {
  const bookingId = useParams();
  const navigate = useNavigate();
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(true);
  const [bookingData, setBookingData] = useState({});
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [paymentType, setPaymentType] = useState("Part Payment");
  const [paymentMethod, setPaymentMethod] = useState("Card");
  const [paymentAmountField, setPaymentAmountField] = useState(false);

  const { register, handleSubmit, control, setValue, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      payment_type: "",
      payment_method: "",
      paymentNote: "",
      paymentAmount: "",
    },
  });

  useEffect(() => {
    setLoading(true);
    axios(process.env.REACT_APP_API_URL + "v1/driver/request-details/" + bookingId?.id, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        let bookingDataTemp = response.data.data;
        setBookingData(bookingDataTemp);
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }, [API_TOKEN, bookingId]);

  const onSubmit = (data) => {
    if (bookingId?.id) {
      data = { ...data, bookingId: bookingId?.id };
    }

    const postData = data;

    axios.post(process.env.REACT_APP_API_URL + "v1/driver/item-picked-up", postData, {
      headers: {
        Authorization: `Bearer ${auth?.api_token}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");

        setTimeout(() => {
          navigate("/driver/today-request-list");
        }, 2000);
      }
    }).catch((error) => {
      setLoading(false);
    });
  }

  const handleChange = (event) => {
    setValue("paymentAmount", "");
    setValue("paymentNote", "");
    setPaymentAmountField(false);
    setPaymentType(event.target.value);
    if (event.target.value === "Full Payment") {
      setValue("paymentAmount", bookingData?.total);
      setPaymentAmountField(true);
    }
  }

  const handleChangeMethod = (event) => {
    setPaymentMethod(event.target.value);
  }

  return (<>
    <div className={`${styles.MainDiv}`}>
      <Loader open={loading} setOpen={setLoading.bind(this)} />
      <div className={`${styles.PageTitleWrap}`}>
        <p className={`${styles.PageTitle}`}>Payment</p>
      </div>
      <div className={`${styles.MainCard}`}>
        <div className={`${styles.StepOneForm}`}>
          <form id="step2-form" onSubmit={handleSubmit(onSubmit)}>
            <div className={`FormHalfGroup`}>
              <FormControl>
                <FormLabel id="demo-controlled-radio-buttons-group">Payment Type</FormLabel>
                <RadioGroup aria-labelledby="demo-controlled-radio-buttons-group" name="payment_type" value={paymentType} onChange={handleChange}>
                  <FormControlLabel value="Unpaid" control={<Radio {...register("payment_type")} />} label="Unpaid" />
                  <FormControlLabel value="Full Payment" control={<Radio {...register("payment_type")} />} label="Full Payment" />
                  <FormControlLabel value="Part Payment" control={<Radio {...register("payment_type")} />} label="Part Payment" />
                </RadioGroup>
              </FormControl>
            </div>

            {paymentType !== "Unpaid" && (<div>
              <div className={`FormHalfGroup`}>
                <Controller
                  control={control}
                  {...register("paymentAmount", { required: "This field is Required" })}
                  render={({ field }) => (<TextField {...field} label="Amount to Pay*" variant="outlined" disabled={paymentAmountField} />)}
                />
                {errors.paymentAmount && (<span className={`ErrorM`}>{errors?.paymentAmount?.message}</span>)}
              </div>
              <div className={`FormHalfGroup`}>
                <Controller
                  control={control}
                  {...register("paymentNote")}
                  render={({ field }) => (<TextField {...field} label="Enter Payment Note" variant="outlined" multiline rows={4} />)}
                />
              </div>
              <div className={`FormHalfGroup`}>
                <FormControl>
                  <FormLabel id="demo-controlled-radio-buttons-group">Payment Method</FormLabel>
                  <RadioGroup aria-labelledby="demo-controlled-radio-buttons-group" name="payment_method" value={paymentMethod} onChange={handleChangeMethod}>
                    <FormControlLabel value="Cash" control={<Radio {...register("payment_method")} />} label="Cash" />
                    <FormControlLabel value="Card" control={<Radio {...register("payment_method")} />} label="Card" />
                    <FormControlLabel value="Bank Transfer" control={<Radio {...register("payment_method")} />} label="Bank Transfer" />
                  </RadioGroup>
                </FormControl>
              </div>
            </div>)}
            <div className={`FormButtonArea`}>
              <RouterLink as={Button} to={`/driver/item-details/${bookingId?.id}`} className={`CancelBU`}>Cancel</RouterLink>
              <Button className={`SubmitBU`} type="submit">Finish</Button>
            </div>
          </form>
        </div>
      </div>
    </div>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
}

export default DriverPaymentDetails;